/**
 * NjitPhotoGallery behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Formstone.NoConflict();


  /**
   * The photo gallery behavior object.
   */
  Drupal.njitPhotoGallery = function (id, items) {
    var data = {total: items.length, items: []};
    for (var i in items) {
      data.items[i] = {item: $.templates("#photoGallerySlide").render(items[i])};
    }

    var gallery = $.templates("#photoGallery").render(data);
    var $trigger = $('.trigger-gallery-modal');
    var $modal = Drupal.njitPhotoGalleryModal(gallery, $trigger, id);

    $trigger.on('click', function (e) {
      var $carousel = $(".carousel", $modal).fsCarousel({
        paged: false,
        pagination: false,
        infinite: true,
        controls: {
          "contain": ".controls",
          "previous": ".previous",
          "next": ".next"
        }
      });

      $carousel.on('update.carousel', function (event, index) {
        $modal.find('.slides-info-number').text(index + 1);
      });

      $('body').once().keydown(function (e) {
        if (e.keyCode == 37) {
          $(".controls button.previous", $modal).click();
        }
        else if (e.keyCode == 39) {
          $(".controls button.next", $modal).click();
        }
        else if (e.keyCode == 27) {
          $(".close", $modal).click();
        }
      });

    });
  };

  /**
   * Modal builder.
   *
   * @param html
   * @param $trigger
   * @param id
   * @returns {*|HTMLElement}
   */
  Drupal.njitPhotoGalleryModal = function (html, $trigger, id) {
    var modal = $.templates("#photoGalleryModalWrapper")
      .render({content: html, id: id});
    var $modal = $(modal);
    $('body').append($modal);

    $trigger.on('click', function () {
      $('body, html').addClass('modal-open');
      $('#modal-' + $(this).attr('id')).addClass('modal-open');
      $('.fs-carousel').fsCarousel('reset');
      _.delay(function (text) {
        $('.fs-carousel').fsCarousel('reset');
      }, 200);

    });

    $('.close', $modal).on('click', function () {
      $('body, html').removeClass('modal-open');
      $modal.removeClass('modal-open');
    });

    return $modal;
  };

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.njitPhotoGallery.attach}}
   */
  Drupal.behaviors.njitPhotoGallery = {
    attach: function (context, settings) {
      // Emulate the data-carousel-items in the gallery item.
      // In real world this must be attached on the backend or expanded in
      // Drupal.settings.njitPhotoGalleryItems.

      if(typeof photoGalleryData != 'undefined') { 
        $('#gallery-0').attr('data-carousel-items', JSON.stringify(photoGalleryData));

        // Attach the modals.
        $('.photo-gallery .trigger-gallery-modal').once('photo-gallery-modal', function () {
          Drupal.njitPhotoGallery($(this).attr('id'), $(this).data('carousel-items'));
        });
      }

    }
  }

})(Drupal, jQuery);
